import axios from 'axios';

const API_URL = 'https://nathnagribareilly.com/api/index.php?action=getTemples';

// ----------------- TEMPLES -----------------
let dummyTemples = [
  { id: 1, name: "अलखनाथ मंदिर (Alakhnath Temple)", description: "दशनामी संन्यासियों के आनंद अखाड़े का मुख्यालय। भक्त यहां प्रार्थना करते हैं और जानवरों को भोजन कराते हैं।", full_description: "अलखनाथ मंदिर दशनामी संन्यासियों के आनंद अखाड़ा आदेश का मुख्यालय है। यह बरेली के प्रमुख शिव मंदिरों में से एक है। इस परिसर में कई छोटे मंदिर और भगवान शिव की विशाल प्रतिमाएं स्थित हैं।", location: "किला रोड, बरेली", morning_timing: "सुबह 5:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1599839619722-39751411ea63?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3619, lng: 79.4217, rating: 4.8, reviews: 124 },
  { id: 2, name: "त्रिवटी नाथ मंदिर (Trivati Nath Temple)", description: "शहर के मध्य में स्थित यह सुंदर मंदिर भगवान शिव को समर्पित है और अपने शांत वातावरण के लिए प्रसिद्ध है।", full_description: "त्रिवटी नाथ मंदिर बरेली के प्राचीन नाथ मंदिरों में से एक है। यह शहर के मध्य भाग में स्थित है। पौराणिक कथाओं के अनुसार भगवान शिव ने यहां एक चरवाहे को दर्शन दिए थे।", location: "मैकनेयर रोड, बरेली", morning_timing: "सुबह 4:30 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 10:00", image: "https://images.unsplash.com/photo-1604580864964-0462f5d5b1a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3725, lng: 79.4320, rating: 4.6, reviews: 312 },
  { id: 3, name: "मढ़ीनाथ मंदिर (Madhinath Temple)", description: "भगवान शिव को समर्पित एक प्राचीन मंदिर, जिसका इतिहास बरेली शहर की स्थापना से जुड़ा है।", full_description: "मढ़ीनाथ मंदिर भगवान शिव को समर्पित है और उन सात ऐतिहासिक नाथ मंदिरों में से एक है जिनके कारण बरेली को 'नाथ नगरी' कहा जाता है। इसका इतिहास पौराणिक गाथाओं से जुड़ा है।", location: "मढ़ीनाथ, बरेली", morning_timing: "सुबह 5:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1514222049077-df903dce311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3450, lng: 79.4120, rating: 4.5, reviews: 189 },
  { id: 4, name: "धोपेश्वरनाथ मंदिर (Dhopeshwarnath Temple)", description: "यह भव्य मंदिर अपने विशाल पवित्र कुंड और ऐतिहासिक महत्व के लिए प्रसिद्ध है।", full_description: "धोपेश्वरनाथ मंदिर भगवान शिव को समर्पित है। यह मंदिर परिसर के समीप स्थित विशाल जल निकाय (कुंड) के लिए भी विशेष रूप से जाना जाता है जहां भक्त पवित्र स्नान करते हैं।", location: "कैंटोनमेंट, बरेली", morning_timing: "सुबह 5:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 8:30", image: "https://images.unsplash.com/photo-1621217637843-c052822aefad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3401, lng: 79.4452, rating: 4.7, reviews: 215 },
  { id: 5, name: "बनखंडीनाथ मंदिर (Bankhandinath Temple)", description: "शहर की भीड़भाड़ से थोड़ा दूर हरियाली के बीच स्थित एक शांत और ध्यान योग के लिए उपयुक्त मंदिर।", full_description: "बनखंडीनाथ मंदिर प्राकृतिक हरियाली के बीच स्थित है और प्रार्थना और ध्यान के लिए एक अद्भुत शांत वातावरण प्रदान करता है।", location: "सुभाष नगर, बरेली", morning_timing: "सुबह 6:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 8:00", image: "https://images.unsplash.com/photo-1596484552803-0c46b97607a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3305, lng: 79.4201, rating: 4.4, reviews: 156 },
  { id: 6, name: "तपेश्वरनाथ मंदिर (Tapeshwarnath Temple)", description: "पुरानी पारंपरिक शैली का नाथ मंदिर, जो अपनी दैनिक आरती और भव्य वास्तुकला के लिए प्रसिद्ध है।", full_description: "तपेश्वरनाथ मंदिर अपनी पारंपरिक वास्तुकला और जीवंत दैनिक आरती से भक्तों को आकर्षित करता है। स्थानीय लोग बड़ी संख्या में यहां दर्शन के लिए आते हैं।", location: "सुभाष नगर (पुराना शहर), बरेली", morning_timing: "सुबह 5:30 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1582555172866-f73bb12a2ab3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3380, lng: 79.4050, rating: 4.6, reviews: 198 },
  { id: 7, name: "पशुपतिनाथ मंदिर (Pashupatinath Temple)", description: "भगवान शिव के पशुपतिनाथ स्वरूप को समर्पित एक नवनिर्मित और भव्य नाथ मंदिर।", full_description: "भगवान शिव के पशुपतिनाथ रूप की भव्यता को दर्शाने के लिए बनाया गया यह मंदिर, नाथ मंदिरों की श्रृंखला में एक नया और महत्वपूर्ण आध्यात्मिक केंद्र है।", location: "पीलीभीत बायपास रोड, बरेली", morning_timing: "सुबह 6:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3840, lng: 79.4820, rating: 4.9, reviews: 420 },
  { id: 8, name: "पशुपतिनाथ मंदिर (Pashupatinath Temple)", description: "भगवान शिव के पशुपतिनाथ स्वरूप को समर्पित एक नवनिर्मित और भव्य नाथ मंदिर।", full_description: "भगवान शिव के पशुपतिनाथ रूप की भव्यता को दर्शाने के लिए बनाया गया यह मंदिर, नाथ मंदिरों की श्रृंखला में एक नया और महत्वपूर्ण आध्यात्मिक केंद्र है।", location: "पीलीभीत बायपास रोड, बरेली", morning_timing: "सुबह 6:00 - दोपहर 12:00", evening_timing: "शाम 4:00 - रात 9:00", image: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", lat: 28.3840, lng: 79.4820, rating: 4.9, reviews: 420 }
];

// ----------------- BLOGS -----------------
let dummyBlogs = [
  { id: 1, title: "नाथ नगरी का इतिहास: सात शिव मंदिरों की कहानी", excerpt: "बरेली को नाथ नगरी क्यों कहा जाता है? आइए जानते हैं इन प्राचीन शिव मंदिरों के पीछे की पौराणिक कथाएं और इतिहास।", content: "<p>बरेली को 'नाथ नगरी' के रूप में जाना जाता है क्योंकि इस शहर के चारों कोनों और मध्य में भगवान शिव के सात प्राचीन मंदिर स्थित हैं। इन मंदिरों का निर्माण और महत्व अत्यंत प्राचीन है। त्रिवटी नाथ, अलखनाथ, मढ़ीनाथ, धोपेश्वरनाथ, बनखंडीनाथ, तपेश्वरनाथ, और पशुपतिनाथ - ये सातों मंदिर बरेली की आध्यात्मिक पहचान हैं। हर शिवरात्रि और सावन के महीने में यहां लाखों भक्तों की भीड़ उमरती है।...</p>", date: "12 मार्च 2026", author: "Admin", image: "https://images.unsplash.com/photo-1552554625-ecc199e46a9a", status: "published", rating: 4.5, ratingCount: 12 },
  { id: 2, title: "सावन मास की तैयारियां: कांवड़ यात्रा और शिव पूजा", excerpt: "इस सावन मास में भगवान शिव की आराधना का विशेष महत्व है। जानें कि इस बार कांवड़ यात्रा के लिए क्या-क्या खास तैयारियां की गई हैं।", content: "<p>सावन के महीने में बरेली के नाथ मंदिरों की रौनक देखते ही बनती है। दूर-दूर से कांवड़िये गंगा जल लेकर भगवान शिव का अभिषेक करने आते हैं। इस साल प्रशासन ने सभी मंदिरों के आस-पास विशेष सुरक्षा और भक्तों के लिए जलपान की व्यवस्था की है। सावन के हर सोमवार को विशेष रुद्राभिषेक का भी आयोजन होगा।</p>", date: "24 जुलाई 2026", author: "Raman", image: "https://images.unsplash.com/photo-1623062635900-514be0f09852", status: "published", rating: 5, ratingCount: 8 },
  { id: 3, title: "महाशिवरात्रि मेला - 2026 (Pending Approval)", excerpt: "आगामी शिवरात्रि मेले के लिए प्रशासन की नई व्यवस्था।", content: "<p>यह एक उपयोगकर्ता द्वारा सबमिट किया गया ब्लॉग है जिसे स्वीकृति की प्रतीक्षा है।</p>", date: "28 मार्च 2026", author: "Devotee User", image: "https://images.unsplash.com/photo-1514222049077-df903dce311a", status: "pending", rating: 0, ratingCount: 0 }
];

// ----------------- COMMENTS -----------------
let dummyComments = [
  { id: 101, blogId: 1, text: "बहुत ही ज्ञानवर्धक लेख!", author: "Vikas M.", date: "13 मार्च 2026" },
  { id: 102, blogId: 1, text: "मुझे त्रिवटी नाथ मंदिर की आरती का समय क्या मिलेगा?", author: "Priya S.", date: "14 मार्च 2026" },
];

// ----------------- ADS -----------------
let dummyAds = [
  { id: 1, title: "Spiritual Book Store", link: "https://example.com", image: "https://via.placeholder.com/300x250?text=Ad:+Gita+Store", placement: "sidebar", status: "active" },
  { id: 2, title: "Bareilly Tours", link: "https://example.com", image: "https://via.placeholder.com/728x90?text=Ad:+City+Tours", placement: "banner", status: "active" },
];

export const getTemples = async () => {
  try {
    const response = await axios.get(API_URL);
    if (Array.isArray(response.data) && response.data.length === 0) return dummyTemples;
    const data = response.data.map(t => {
      const match = dummyTemples.find(d => d.id === t.id);
      return { ...t, rating: t.rating || (match ? match.rating : 4.5), reviews: t.reviews || (match ? match.reviews : 100) };
    });
    return data;
  } catch {
    return dummyTemples;
  }
};

export const getTempleById = async (id) => {
  const temples = await getTemples();
  return temples.find(t => t.id.toString() === id.toString()) || null;
};

export const submitTempleRating = async (templeId, rating) => {
  return new Promise(resolve => setTimeout(() => resolve({ success: true, message: 'Rating saved' }), 800));
};

export const addTemple = async (templeData) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'addTemple')}`, templeData);
    if(response.data.status === 'success') {
       // Also push to local array so UI updates instantly without refetching if preferable, but let's just return true.
       const newTemple = { id: response.data.id || Date.now(), rating: 0, reviews: 0, ...templeData };
       dummyTemples.push(newTemple);
       return { success: true, temple: newTemple };
    }
    return { success: false, message: "Failed to add temple" };
  } catch (error) {
    console.error("Add temple error", error);
    return { success: false, message: "Network error" };
  }
};

export const updateTemple = async (id, templeData) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'updateTemple')}`, { id, ...templeData });
    if(response.data.status === 'updated') {
       dummyTemples = dummyTemples.map(t => t.id === id ? { ...t, ...templeData } : t);
       return { success: true };
    }
    return { success: false, message: "Failed to update temple" };
  } catch (error) {
    console.error("Update temple error", error);
    return { success: false, message: "Network error" };
  }
};

export const deleteTemple = async (id) => {
  try {
    const response = await axios.post(`${API_URL.replace('getTemples', 'deleteTemple')}`, { id });
    if(response.data.status === 'deleted') {
       dummyTemples = dummyTemples.filter(t => t.id !== id);
       return { success: true };
    }
    return { success: false, message: "Failed to delete temple" };
  } catch (error) {
    console.error("Delete temple error", error);
    return { success: false, message: "Network error" };
  }
};

export const uploadFileToServer = async (file) => {
  try {
    const formData = new FormData();
    formData.append("image", file);
    
    const response = await axios.post(`${API_URL.replace('getTemples', 'uploadImage')}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    if (response.data.success) {
      return { success: true, url: response.data.url };
    }
    return { success: false, message: response.data.message || "Failed to upload" };
  } catch (error) {
    console.error("Upload error", error);
    return { success: false, message: "Upload failed: Network error" };
  }
};

// ----------------- USERS -----------------
let dummyUsers = [
  { id: 1, name: 'Main Admin', email: 'admin@nathnagri.com', password: 'admin123', role: 'admin' },
  { id: 2, name: 'Content Editor', email: 'editor@nathnagri.com', password: 'editor123', role: 'editor' },
  { id: 3, name: 'Devotee User', email: 'user@test.com', password: 'user123', role: 'user' }
];

/* --- Auth & Users API --- */
const BASE_API_URL = 'https://nathnagribareilly.com/api/index.php';

export const authenticateUser = async (email, password) => {
  try {
    // Attempt to login using the actual PHP backend
    const response = await axios.post(`${BASE_API_URL}?action=login`, { email, password });

    // Safely parse potentially broken PHP output (like empty strings or HTML warnings)
    if (typeof response.data !== 'object' || response.data === null) {
      console.error("PHP Returned Invalid Data:", response.data);
      return { success: false, message: 'Server did not return valid JSON. There is likely an error in the PHP file.' };
    }

    return response.data;
  } catch (error) {
    console.error("Login Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const getUsers = async () => {
  try {
    const response = await axios.get(`${BASE_API_URL}?action=getUsers`);
    return Array.isArray(response.data) ? response.data : dummyUsers;
  } catch (error) {
    return dummyUsers;
  }
};

export const signupUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=signup`, userData);
    return response.data;
  } catch (error) {
    console.error("Signup User Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=createUser`, userData);
    return response.data;
  } catch (error) {
    console.error("Create User Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=deleteUser`, { id });
    return response.data;
  } catch (error) {
    console.error("Delete User Axios Error:", error);
    const errorMessage = error.response ? `HTTP ${error.response.status}` : error.message;
    return { success: false, message: `Server error: ${errorMessage}` };
  }
};

export const updateUserRole = async (id, newRole) => {
  // Fallback to dummy behavior currently since there is no update PHP block provided yet
  return new Promise(resolve => {
    dummyUsers = dummyUsers.map(u => u.id === id ? { ...u, role: newRole } : u);
    setTimeout(() => resolve({ success: true }), 300);
  });
};

/* --- Blog API --- */
export const getBlogs = async (status = "published") => {
  try {
    const res = await axios.get(`${BASE_API_URL}?action=getBlogs`);
    let blogs = Array.isArray(res.data) ? res.data : [];
    if (status !== "all") {
      blogs = blogs.filter(b => b.status === status);
    }
    return blogs.length ? blogs : dummyBlogs;
  } catch(e) {
    return dummyBlogs.filter(b => status === 'all' || b.status === status);
  }
};

export const getBlogById = async (id) => {
  const blogs = await getBlogs("all");
  return blogs.find(b => b.id.toString() === id.toString()) || null;
};

export const submitBlog = async (blogData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=addBlog`, blogData);
    if(response.data.success) {
      return { success: true, blog: { ...blogData, id: Date.now() } };
    }
    return { success: false };
  } catch (error) {
    return { success: false };
  }
};

export const editBlogServer = async (blogData) => {
  try {
    const response = await axios.post(`${BASE_API_URL}?action=editBlog`, blogData);
    if(response.data.success) {
      return { success: true };
    }
    return { success: false };
  } catch (error) {
    return { success: false };
  }
};

export const updateBlogStatus = async (blogId, status) => {
  try {
    await axios.get(`${BASE_API_URL}?action=approveBlog&id=${blogId}`);
    return { success: true };
  } catch(e) {
    return { success: false };
  }
};

export const rateBlog = async (blogId, ratingVal) => {
  return new Promise(resolve => {
    dummyBlogs = dummyBlogs.map(b => {
      if (b.id === blogId) {
        const newCount = b.ratingCount + 1;
        const newRating = ((b.rating * b.ratingCount) + ratingVal) / newCount;
        return { ...b, rating: newRating.toFixed(1), ratingCount: newCount };
      }
      return b;
    });
    setTimeout(() => resolve({ success: true }), 500);
  });
};

/* --- Comments API --- */
export const getCommentsForBlog = async (blogId) => {
  return new Promise(resolve => setTimeout(() => resolve(dummyComments.filter(c => c.blogId === parseInt(blogId))), 300));
};

export const addComment = async (blogId, text, author) => {
  return new Promise(resolve => {
    const comment = { id: Date.now(), blogId: parseInt(blogId), text, author, date: new Date().toLocaleDateString('hi-IN') };
    dummyComments.push(comment);
    setTimeout(() => resolve({ success: true, comment }), 400);
  });
};

/* --- Ads API --- */
export const getAds = async () => {
  return new Promise(resolve => setTimeout(() => resolve(dummyAds), 200));
};

export const getAdByPlacement = async (placement) => {
  return new Promise(resolve => setTimeout(() => resolve(dummyAds.find(ad => ad.placement === placement && ad.status === 'active') || null), 100));
};

export const saveAd = async (adData) => {
  return new Promise(resolve => {
    if (adData.id) {
      dummyAds = dummyAds.map(ad => ad.id === adData.id ? adData : ad);
    } else {
      dummyAds.push({ ...adData, id: Date.now() });
    }
    setTimeout(() => resolve({ success: true }), 400);
  });
};

export const deleteAd = async (id) => {
  return new Promise(resolve => {
    dummyAds = dummyAds.filter(ad => ad.id !== id);
    setTimeout(() => resolve({ success: true }), 300);
  });
};